import { render, staticRenderFns } from "./Varios.vue?vue&type=template&id=a19079a4&scoped=true"
import script from "./Varios.vue?vue&type=script&lang=js"
export * from "./Varios.vue?vue&type=script&lang=js"
import style0 from "./Varios.vue?vue&type=style&index=0&id=a19079a4&prod&lang=scss&scoped=true"
import style1 from "./Varios.vue?vue&type=style&index=1&id=a19079a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19079a4",
  null
  
)

export default component.exports